<template>
  <div
    v-if="state === 'loading'"
    class="grid gap-3"
    role="status"
    :aria-label="loadingLabel"
  >
    <div
      v-for="item in 3"
      :key="item"
      class="animate-pulse rounded-xl border border-white/[0.07] bg-white/[0.03] p-4"
    >
      <div class="h-4 w-2/5 rounded bg-white/10"></div>
      <div class="mt-3 h-3 w-4/5 rounded bg-white/[0.07]"></div>
      <div class="mt-2 h-3 w-3/5 rounded bg-white/[0.07]"></div>
    </div>
    <span class="sr-only">{{ loadingLabel }}</span>
  </div>

  <div
    v-else-if="state === 'error'"
    class="flex flex-col items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] px-5 py-8 text-center"
    role="alert"
  >
    <IconFbochas name="reloj" :size="22" class="text-bochas-text-muted" />
    <p class="mt-3 text-sm font-medium text-white">
      {{ errorMessage }}
    </p>
    <button
      type="button"
      class="mt-4 rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10"
      @click="$emit('retry')"
    >
      Reintentar
    </button>
  </div>

  <div
    v-else-if="state === 'empty'"
    class="rounded-xl border border-white/[0.07] bg-white/[0.02] px-5 py-8 text-center text-sm text-bochas-text-muted"
  >
    {{ emptyMessage }}
  </div>
</template>

<script setup>
import IconFbochas from "@/components/Icons/IconFbochas.vue";

defineProps({
  state: {
    type: String,
    required: true,
  },
  emptyMessage: {
    type: String,
    default: "No hay contenido disponible.",
  },
  errorMessage: {
    type: String,
    default: "No pudimos cargar esta sección.",
  },
  loadingLabel: {
    type: String,
    default: "Cargando contenido",
  },
});

defineEmits(["retry"]);
</script>
